var App = App || {};

App.ZagPlugins = (function ($) {
    'use strict';

    const defaultStagger = 200;
    const defaultParallax = 6;
    function ScrollAnimate() {

        $(".widget-masthead .widget-masthead-content-layout").ZagScrollAnimate({
            offset: 75,
            targets: [
                { selector: ".widget-masthead-recommendation", type: "animate__fadeInLeft", stagger: 0 }
            ]
        });

        $(".widget-masthead .widget-masthead-icons").ZagScrollAnimate({
            offset: 75,
            targets: [
                { selector: ".shared-icon", type: "animate__fadeInUp", stagger: defaultStagger }
            ]
        });

        $(".widget-goals .widget-goals-buttons").ZagScrollAnimate({
            offset: 75,
            targets: [
                { selector: "li", type: "animate__fadeInUp", stagger: defaultStagger }
            ]
        });

        $(".widget-promos.cards .widget-promos-layout").ZagScrollAnimate({
            offset: 75,
            targets: [
                { selector: ".promo-card", type: "animate__fadeInUp", stagger: 0 }
            ]
        });

        $(".widget-promos.single .widget-promo-single").ZagScrollAnimate({
            offset: 75,
            targets: [
                { selector: ".widget-promo-single-icon", type: "animate__tada", stagger: 0 }
            ]
        });

        $(".widget-promos.cross").ZagScrollAnimate({
            offset: 75,
            targets: [
                { selector: ".widget-promo-cross", type: "animate__fadeInUp", stagger: 0 }
            ]
        });

        $(".widget-icons .shared-icons").ZagScrollAnimate({
            offset: 75,
            targets: [
                { selector: ".shared-icon", type: "animate__fadeInUp", stagger: defaultStagger }
            ]
        });

        $(".widget-resources").ZagScrollAnimate({
            offset: 75,
            targets: [
                { selector: ".widget-resources-row", type: "animate__fadeInUp", stagger: 0 }
            ]
        });

        $(".widget-testimonials .widget-testimonials-layout").ZagScrollAnimate({
            offset: 75,
            targets: [
                { selector: ".item-testimonial", type: "animate__fadeInUp", stagger: 0 }
            ]
        });

        $(".widget-category .widget-category-list").ZagScrollAnimate({
            offset: 75,
            targets: [
                { selector: ".item-category", type: "animate__fadeInUp", stagger: defaultStagger }
            ]
        });

        $(".widget-category .widget-category-compare").ZagScrollAnimate({
            offset: 75,
            targets: [
                { selector: ".widget-category-compare-table", type: "animate__fadeInUp", stagger: defaultStagger }
            ]
        });

        $(".widget-structure").ZagScrollAnimate({
            offset: 75,
            targets: [
                { selector: ".widget-structure-image", type: "animate__fadeInUp", stagger: 0 }
            ]
        });

        $(".widget-rates").ZagScrollAnimate({
            offset: 75,
            targets: [
                { selector: ".widget-rates-cards", type: "animate__fadeInUp", stagger: 0 }
            ]
        });

        $(".blog-masthead .blog-masthead-featured").ZagScrollAnimate({
            offset: 75,
            targets: [
                { selector: ".blogPost-featured-image, .blogPost-featured-content", type: "animate__fadeInUp", stagger: defaultStagger }
            ]
        });

        $(".blogPost-masthead").ZagScrollAnimate({
            offset: 75,
            targets: [
                { selector: ".blogPost-masthead-image", type: "animate__fadeInUp", stagger: 0 }
            ]
        });

    }

    function Parallax() {
        $(".widget-blogPosts").each(function () {
            $(this).find(".widget-blogPosts-bg").ZagParallax({ divisor: defaultParallax });
        });

        $(".widget-promos.single").each(function () {
            $(this).find(".widget-promo-single-bg").ZagParallax({ divisor: defaultParallax });
        });

        $(".widget-rich-text-branded").each(function () {
            $(this).find(".widget-rich-text-branded-bg").ZagParallax({ divisor: defaultParallax });
        });
    }

    return {
        ScrollAnimate: ScrollAnimate,
        Parallax: Parallax
    };

})(jQuery);

$(function () {
    App.ZagPlugins.ScrollAnimate();
    App.ZagPlugins.Parallax();
});